import { render, staticRenderFns } from "./LocalityItem.vue?vue&type=template&id=0deb2650&"
import script from "./LocalityItem.vue?vue&type=script&lang=ts&"
export * from "./LocalityItem.vue?vue&type=script&lang=ts&"
import style0 from "./LocalityItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports